var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.127,
    height: 40,
    viewBox: "0 0 33.127 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-253.241 -229.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9235",
    "data-name": "Path 9235",
    d: "M361.06,284.719a2.727,2.727,0,1,0-2.725-2.727A2.729,2.729,0,0,0,361.06,284.719Zm0-3.894a1.168,1.168,0,1,1-1.166,1.168A1.169,1.169,0,0,1,361.06,280.825Z",
    transform: "translate(-91.256 -43.63)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9236",
    "data-name": "Path 9236",
    d: "M279.983,232.333v-1.754a1.559,1.559,0,0,0-3.118,0v1.415H263.079V230.58a1.559,1.559,0,1,0-3.118,0v1.667a8.778,8.778,0,0,0-6.72,8.518v19.486a8.78,8.78,0,0,0,8.769,8.769H277.6a8.78,8.78,0,0,0,8.769-8.769V240.765a8.78,8.78,0,0,0-6.384-8.432Zm-20.022,1.926v1a1.559,1.559,0,1,0,3.118,0v-1.313h13.787v1.313a1.559,1.559,0,1,0,3.118,0v-.874a6.825,6.825,0,0,1,4.435,6.382v1.754H255.19v-1.754a6.831,6.831,0,0,1,4.772-6.505ZM277.6,267.07H262.01a6.828,6.828,0,0,1-6.82-6.82V245.635h29.23V260.25a6.828,6.828,0,0,1-6.821,6.82Z",
    transform: "translate(0 0)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9237",
    "data-name": "Path 9237",
    d: "M309.328,405.2l1.224.5a.78.78,0,0,0,.594-1.442l-1.224-.5a.78.78,0,0,0-.594,1.442Z",
    transform: "translate(-48.283 -151.68)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9238",
    "data-name": "Path 9238",
    d: "M348.919,366.2a.778.778,0,0,0,.719.478.761.761,0,0,0,.3-.061.779.779,0,0,0,.417-1.02l-.512-1.222a.78.78,0,1,0-1.438.6Z",
    transform: "translate(-82.582 -117.116)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9239",
    "data-name": "Path 9239",
    d: "M401.126,366.287a.779.779,0,0,0,1.015-.43l.5-1.228a.779.779,0,0,0-1.445-.584l-.5,1.228a.779.779,0,0,0,.431,1.014Z",
    transform: "translate(-127.99 -116.822)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9240",
    "data-name": "Path 9240",
    d: "M435.938,404.933a.774.774,0,0,0,.306-.062l1.219-.519a.779.779,0,1,0-.611-1.434l-1.219.519a.779.779,0,0,0,.306,1.5Z",
    transform: "translate(-157.964 -150.946)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9241",
    "data-name": "Path 9241",
    d: "M438.005,455.738l-1.231-.493a.78.78,0,0,0-.58,1.448l1.231.493a.78.78,0,1,0,.58-1.448Z",
    transform: "translate(-158.438 -196.389)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9242",
    "data-name": "Path 9242",
    d: "M403.486,490.356a.779.779,0,1,0-1.43.618l.526,1.217a.779.779,0,0,0,.715.471.767.767,0,0,0,.309-.064.78.78,0,0,0,.406-1.024Z",
    transform: "translate(-129.164 -226.517)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9243",
    "data-name": "Path 9243",
    d: "M351.451,490.767a.782.782,0,0,0-1.012.439l-.487,1.233a.781.781,0,0,0,.439,1.012.781.781,0,0,0,1.012-.439l.487-1.233A.779.779,0,0,0,351.451,490.767Z",
    transform: "translate(-83.931 -227.236)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9244",
    "data-name": "Path 9244",
    d: "M311.171,457.211l-1.215.532a.779.779,0,0,0,.313,1.493.758.758,0,0,0,.311-.065l1.215-.532a.779.779,0,1,0-.624-1.428Z",
    transform: "translate(-48.841 -198.087)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9245",
    "data-name": "Path 9245",
    d: "M347.77,401.443a2.36,2.36,0,0,0,.111-.709h.013l-.192-7.641H347.7a2.378,2.378,0,0,0-4.355-1.443l0,0-4.712,6.017.01.008a2.356,2.356,0,0,0,1.156,3.645v0l4.957,1.641h0a2.392,2.392,0,0,0,3.021-1.518Zm-2.919-8.567.014-.017.006-.009h0a.466.466,0,0,1,.884.294h0s0,0,0,.007a.162.162,0,0,0-.009.015l.06,2.145,0,0,.069,2.752-4.04-1.338Zm1.085,7.828a.485.485,0,0,1-.016.127.442.442,0,0,1-.56.281h0l-2.228-.736-.472-.157h0l-2.225-.736h0l0,0-.008,0,0,0a.442.442,0,0,1-.269-.552.414.414,0,0,1,.1-.164l0,0,.312-.4,5.366,1.775.013.518c0,.007,0,.015,0,.021v.031Z",
    transform: "translate(-73.754 -140.294)",
    fill: "#272d3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.b6d1dec792697642a7b4fb2fe9a8d0ea.svg";
export { ForwardRef as ReactComponent };